import { Component, computed, effect, ElementRef, signal } from '@angular/core'; 
import { AppService } from '../../../../Services/app.service';
import { WindowPrinterService } from './window-printer.service';
import { SharedModule } from 'projects/evolutics-shared-lib/src/lib/Shared/shared.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'window-printer',
  imports: [SharedModule],
  templateUrl: './window-printer.component.html',
  styleUrl: './window-printer.component.scss',
})
export class WindowPrinterComponent {
  readonly isPrinting = computed(() => this.windowPrinterService.isPrinting());

  constructor(
    public el: ElementRef,
    public appS: AppService,
    public windowPrinterService: WindowPrinterService,
  ) {
    effect(() => {
      const printing = this.isPrinting();
      const printingClass = 'show-printing';
      if (printing) this.el.nativeElement.classList.add(printingClass);
      else this.el.nativeElement.classList.remove(printingClass);
    });
  }

  download() {
    this.windowPrinterService.isPrinting.set(true);
    setTimeout(() => {
      window.print();
    }, 500);
    // this.appS.isPrinting.set(false);
  }
}
